import { theme } from '@nobia/zeus-components/lib/styled'

export default {
  section: {
    bgColor: '#EEF1F2',
    color: '#000',
    fontSize: '26px',
    fontWeight: '500',
  },
  banner: {
    color: '#fff',
    bgColor: '#0D5E66',
  },
  header: {
    maxWidth: '985px',
  },
  tooltip: {
    color: '#fff',
    bgColor: '#2d5563',
  },
  card: {
    border: {
      selected: '#000',
      default: '#EEF1F2',
    },
  },
  selection: {
    textAlign: 'left',
  },
  font: {
    headings: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: '900',
      title: {
        fontSizeSm: '30px',
        lineHeightSm: '38px',
        fontSizeLg: '42px',
        lineHeightLg: '48px',
      },
    },
    preamble: {
      fontFamily: 'Inter, sans-serif',
      fontWeight: '400',
    },
    paragraph: {
      fontFamily: 'Inter, sans-serif',
    },
  },
  button: {
    fontWeight: '700',
    borderRadius: '25px',
    padding: '15px 55px',
  },
  costSummary: {
    totalCost: {
      fontSize: '18px',
    },
    link: {
      fontSize: '13px',
    },
  },
  email: {
    error: {
      color: 'red',
    },
    label: {
      fontSize: '14px',
    },
    wrapper: {
      minWidth: '400px',
    },
    padding: '30px',
  },
  badaPromo: {
    title: {
      fontSize: '32px',
      lineHeight: '38px',
    },
    image: {
      maxWidth: '460px',
    },
    wrapper: {
      padding: '80px 96px 30px',
    },
  },
  colors: {
    primary: '#333333',
    toneA: '#EEF1F2',
    banner: '#0D5E66',
    button: '#0D5E66',
    badaBlock: theme('colors.white'),
  },
}
